const baseUrl = (process.env.NODE_ENV=='production')?'http://apiv2.zhongzhanbao.com':'http://localhost:5000'

export default{
    baseUrl
}